export default "__VITE_ASSET__T$SMhtiB__"